"use client";

import { useContext } from "react";
import { trans } from "@/service/i18n/i18n";
import { Button } from "@/components/ui/button";
import { UserContext } from "@/contexts/user-context";
import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";

export const ConfirmNewsletter = ({ redirectTo }: { redirectTo: string }) => {
  const user = useContext(UserContext);

  const handleUpdate = () => {
    if (redirectTo) {
      window.location.href = redirectTo;
    } else {
      window.location.reload();
    }
  };

  return (
    <>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        {trans("permission.actions.confirm_newsletter.description")}
      </p>

      <div className="flex items-center justify-between gap-4">
        <Button asChild={true} className={"mb-4 w-full"}>
          <Link href={createPath("homepage")}>
            {trans("back_to_main_page")}
          </Link>
        </Button>
        <Button asChild={true} variant={"ghost"}>
          <a href={createPath("homepage")}>
            {trans("permission.actions.confirm_newsletter.main_page")}
          </a>
        </Button>
      </div>
    </>
  );
};
